import { Box,Typography } from "@mui/material";
export default function Row({ title, children, backgroundColor }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: { xs:'column', md:'row' }, width: '100%' }}>
      <Box sx={{
        width: { xs:'100%', md:'25%' },
        flexShrink: 0,
        backgroundColor: backgroundColor,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        p:2,
      }}>
        <Typography sx={{
          fontFamily:'Segoe UI',
          fontSize:{ xs:'30px',md:'30px', lg:'40px' },
          fontWeight:'bold',
          color:'#fff',
          textAlign:'center',
       //   marginTop:'-20px' moze przesunąć w górę lekko?
        }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{
        backgroundColor:backgroundColor,
        flex:'1 1 auto',
       // p:{ xs:2, md:4 }
      }}>
        {children}
      </Box>
    </Box>
  );
}
